import Box, { Item } from 'devextreme-react/box';
import { useContext, } from 'react';
import { useAuth } from '../../../../contexts/auth';
import { Card, Field } from '../../../../layouts';
import { CompanyTypes } from '../../../../types/enums';
import { formatShortDate } from '../../../../utils/date-utils';
import { PurchaseOrderContext } from '../context/PurchaseOrderContext';
import { PricingType } from '../types/PricingType';

export default function PurchaseOrderInformationCard() {

	const { order } = useContext(PurchaseOrderContext);

	function getPricingTypeDescription() {
		switch (order.details.pricingType) {
			case PricingType.Promo:
				return "Promo";
			case PricingType.Standard:
				return "Standard";
			case PricingType.PriceOverride:
				return "Price Override";
		}
	}

	const { user } = useAuth();
	const isServiceProvider = user?.companyTypeId === CompanyTypes.SERVICE_PROVIDER;

	return (
		<>
			<Card
				header={'Sage PO Information'}
			>
				<Box>
					<Item ratio={1}>
						<Field label={'Sage PO #'} >{order.details.poNumber}</Field>
						<Field label={'Order Type'} visible={!isServiceProvider}>{order.details.orderType}</Field>
						<Field label={'Status'} >{order.details.orderStatus}</Field>
						<Field label={'Reason'} visible={!!order.details.holdReason}>{order.details.holdReason}</Field>
						<Field label={'Order Date'} visible={!isServiceProvider}>{formatShortDate(order.details.createdOn)}</Field>
					</Item>
					<Item ratio={1} visible={!isServiceProvider}>
						<Field label={'Sage MO #'} >{order.details.moNumber}</Field>
						<Field label={'Retail Order #'} >{order.details.roNumber}</Field>
						<Field label={'Retail Order Date'} >{formatShortDate(order.details.roDate)}</Field>
						<Field label={'Pricing'} >{getPricingTypeDescription()}</Field>
					</Item>
				</Box>
			</Card>
		</>
	);
}
